import React, { FC, useEffect } from 'react';
import { Kind } from './kind';
import { useKindVersion } from '../../../loaders/useKindVersion';
import { CustomSpinner } from '@yakoffice/custom-spinner';
import { useKindsForEntitySelection } from '../../../loaders/useKindsForEntitySelection';
import { usePageTitle } from '../pageTitleContext/PageTitleContext';
import { useRootStore } from '../../../loaders/useRootStore';

export const KindContainer: FC = () => {

  const rootStore = useRootStore();
  const loadKindsForEntitySelectionResult = useKindsForEntitySelection();
  const kindVersionResult = useKindVersion();
  const { setPageTitle } = usePageTitle();

  useEffect(() => {
    const title = (kindVersionResult.kindVersion !== null && kindVersionResult.kindVersion.isNewKind()) ? 'New' : (kindVersionResult.kindVersion !== null ? kindVersionResult.kindVersion.name : '');

    setPageTitle([title, rootStore.categoryStore.currentCategory ? rootStore.categoryStore.currentCategory.name : 'Kind', 'Configurations']);
  }, [kindVersionResult.kindVersion]);

  return !loadKindsForEntitySelectionResult.isLoaded || !kindVersionResult.isLoaded || kindVersionResult.kindVersion == null
    ? <CustomSpinner spinnerText="Loading kind..." />
    : <Kind kindVersion={kindVersionResult.kindVersion} />;
};
